(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('reporting-pending-field-documents', {
            parent: 'entity',
            url: '/reporting-pending-field-documents',
            data: {
                authorities: ['ROLE_READ_ONLY', 'ROLE_DATA_OPERATOR', 'ROLE_AREA_MANAGEMENT', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
                pageTitle: 'wamasysApp.pendingFieldDocuments.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/reporting-pending-field-documents/reporting-pending-field-documents.html',
                    controller: 'ReportingPendingFieldDocumentsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pendingFieldDocuments');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
